import { render, staticRenderFns } from "./datatable6.vue?vue&type=template&id=38ecd984"
import script from "./datatable6.vue?vue&type=script&lang=js"
export * from "./datatable6.vue?vue&type=script&lang=js"
import style0 from "./datatable6.vue?vue&type=style&index=0&id=38ecd984&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports